import { format } from 'date-fns';

const handleFormatDate = (dateFormats, value, dateFormatKey, options)=>{
    return format(value, dateFormats[dateFormatKey], options);
};
const handleLongDate = (dateFormat, date, options)=>handleFormatDate(dateFormat, date, 'long', options)
;
const handleMidsizeDate = (dateFormat, date, options)=>handleFormatDate(dateFormat, date, 'midsize', options)
;
const handleShortDate = (dateFormat, date, options)=>handleFormatDate(dateFormat, date, 'short', options)
;
const handleFormatTime = (timeFormats, value, timeFormatKey, options)=>{
    return format(value, timeFormats[timeFormatKey || 'default'], options);
};

export { handleFormatDate, handleFormatTime, handleLongDate, handleMidsizeDate, handleShortDate };
//# sourceMappingURL=date-time-helpers.js.map
